// libs
import React from "react";
import { Dropdown, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { LogoutOutlined } from "@ant-design/icons";
import { useKeycloak } from "@react-keycloak/web";
// constants
import { LOCAL_STORAGE } from "../../../constants/localStorageConstants";
// components
import Logo from "../../../components/DashboardLayout/Logo";
import {
  DropDownProfile,
  Notification,
  UserServices,
  MenuIcon,
} from "@dx-hrsol/ui-kit";
// actions
import { setCurrentBranch } from "../../../actions/user/branchSelected/setCurrentBranch";
import { requestApi } from "../../../actions/apiCommon";
// others
import {
  getAllBranchNormalizeMode,
  getCurrentBranchJSON,
} from "../../../config.js";
import BranchSelectedIcon from "../../../icon/BranchSelectedIcon";
import "./styles.less";

import { AXIOS_INSTANCE } from "../../../config.js";

const { SELECTED_BRANCH } = LOCAL_STORAGE;

const HeaderDashBoard = ({
  collapsed,
  avatarData,
  requestionChangeBranch,
  toggle,
  userBasicInfo,
}) => {
  const handleClick = (e) => {
    if (getCurrentBranchJSON.code !== e) {
      localStorage.setItem(
        SELECTED_BRANCH,
        JSON.stringify(getAllBranchNormalizeMode()[e])
      );
      requestionChangeBranch();
      setCurrentBranch(e);
      window.location.replace("/time");
    }
  };

  const logout = () => {
    requestApi.submitFCMToken("");
    localStorage.clear();
    keycloak.logout();
  };

  const dispatch = useDispatch();

  const {
    allNotifications,
    isLoadingNotification,
    isLoadingMore,
    notificationNumber,
  } = useSelector((state) => state.notificationReducer);

  const { keycloak } = useKeycloak();

  return (
    <div className="flex-layout-header-wrapper">
      <div className="logo">
        <MenuIcon onClick={toggle} collapsed={collapsed} />
        <Logo />
      </div>

      <div className="right-header-wrapper">
        <div className="header-branch-selected">
          <Space>
            <div className="header-branch-selected__wrapper-icon">
              <BranchSelectedIcon className="header-branch-selected__icon" />
            </div>
            <div className="header-branch-selected__text">
              {localStorage.getItem(SELECTED_BRANCH)
                ? JSON.parse(localStorage.getItem(SELECTED_BRANCH))["name"]
                : ""}
            </div>
          </Space>
        </div>

        <Notification
          axiosApi={AXIOS_INSTANCE}
          isLoadingMore={isLoadingMore}
          isLoadingNotification={isLoadingNotification}
          allNotifications={allNotifications}
          notificationNumber={notificationNumber}
          dispatch={dispatch}
        />

        <Dropdown
          trigger={["click"]}
          placement="bottom"
          overlay={
            <UserServices
              onClickMenu={handleClick}
              currentBranch={
                localStorage.getItem(SELECTED_BRANCH)
                  ? JSON.parse(localStorage.getItem(SELECTED_BRANCH)).code
                  : ""
              }
            />
          }
        >
          <span
            className="header-button cut-text"
            style={{ maxWidth: "30%", width: "auto" }}
          >
            <img src="/images/services.svg" alt="" />
          </span>
        </Dropdown>

        {avatarData ? (
          <DropDownProfile
            avatar={avatarData}
            fullName={userBasicInfo.fullName}
            email={userBasicInfo.email}
            position={
              userBasicInfo.engineerLevel
                ? userBasicInfo.engineerLevel.name
                : "N/A"
            }
            positionColor={
              userBasicInfo.engineerLevel
                ? userBasicInfo.engineerLevel.description.split('"')[3]
                : ""
            }
            logout={logout}
          />
        ) : (
          <LogoutOutlined
            onClick={() => {
              localStorage.clear();
              keycloak.logout();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default HeaderDashBoard;
